export const getUrlParams = (path = window.location.pathname) => {
  const [, lang, campground] = path.split('/')
  return { lang, campground }
}
